require('./brokerTransferPensionPlansExternalSuccess.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @Utilities
const { formatText, FormattedText } = require('core/i18n').i18n;

// @Components
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const BrokerTransferPensionPlansSummary = require('components/commons/broker/brokerTransferPensionPlansDataSummary/brokerTransferPensionPlansDataSummary');

// @Constants
const {
    BROKER_MYPROFILE_MYWALLET_URL,
    FIRST_STEP,
    SECOND_STEP,
    THIRD_STEP
} = require('constants/index');

class BrokerTransferPensionPlansExternalSuccess extends React.Component {

    constructor(props) {
        super(props);

    }

    buildMainButton() {
        return {
            label: (<FormattedText value="brokerTraspassBetweenMyPlans-successGoToMyWallet" />),
            modifier: "secondary",
            url: BROKER_MYPROFILE_MYWALLET_URL
        };
    }

    buildTitle() {
        return (
            <div className="broker-transfer-pension-plans-External-success__subtitle">
                <FormattedText value="brokerTraspassBetweenMyPlans-successData" />
            </div>
        );
    }

    buildContent() {
        const { 
            immBrokerTransferPensionPlansExternal
        } = this.props;

        const immStep1 = immBrokerTransferPensionPlansExternal.getIn(['steps', FIRST_STEP]);
        const immStep2 = immBrokerTransferPensionPlansExternal.getIn(['steps', SECOND_STEP]);
        const immStep3 = immBrokerTransferPensionPlansExternal.getIn(['steps', THIRD_STEP]);

        const options = {
            planInWallet: immStep2.get('planFromWallet'),
            selectedTypeOption: immStep3.get('selectedTypeOption'),
            selectedFiscOption: immStep3.get('selectedFiscOption'),
            partialAportation: immStep3.get('partialAportation')
        }

        const originPlan = immStep1.get('originPlanData');
        const destinationPlan = immStep2.get('destinationPlanData');

        return (
            <div className="broker-transfer-pension-plans-external-success__summary">
                <BrokerTransferPensionPlansSummary
                    originPlanData={originPlan}
                    destinationPlanData={destinationPlan}
                    options={options} 
                />
            </div>
        );
    }

    render(){
        const successMessage = formatText('brokerTraspassBetweenMyPlans-brokerTraspassBetweenMyPlans_successTitle');
        const mainButton = this.buildMainButton();
        return (
            <div className="broker-transfer-pension-plans-external-success">
                <WizardSuccess
                    successMessage={successMessage}
                    mainButton={mainButton}
                    onMainButtonClick={this.handleSecondaryButton}
                >
                    {this.buildTitle()}
                    {this.buildContent()}
                </WizardSuccess>
            </div>
        )
    }
}

BrokerTransferPensionPlansExternalSuccess.propTypes = {
    immBrokerTransferPensionPlansExternal: PropTypes.object.isRequired
};

module.exports = BrokerTransferPensionPlansExternalSuccess;